export default __webpack_public_path__ + "static/media/growth_icon1.07eee6d8.svg";